/**
 * Toast - Toast notification component
 * Displays notifications with auto-dismiss
 */

import React, { useEffect, useState } from 'react';
import {
  Snackbar,
  Alert,
  AlertProps,
  Box,
  Button
} from '@mui/material';
import ToastService, { Toast as ToastType } from '../../core/notifications/ToastService';

export const ToastContainer: React.FC = () => {
  const [toasts, setToasts] = useState<ToastType[]>([]);

  useEffect(() => {
    const unsubscribe = ToastService.subscribe(setToasts);
    return unsubscribe;
  }, []);

  const handleDismiss = (id: string) => {
    ToastService.dismiss(id);
  };

  return (
    <Box sx={{ position: 'fixed', bottom: 0, right: 0, zIndex: 9999 }}>
      {toasts.map((toast, index) => (
        <Snackbar
          key={toast.id}
          open={true}
          autoHideDuration={toast.duration}
          onClose={() => handleDismiss(toast.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{ mb: index > 0 ? 2 : 0 }}
        >
          <Alert
            onClose={() => handleDismiss(toast.id)}
            severity={toast.variant as AlertProps['severity']}
            sx={{ width: '100%', minWidth: '300px' }}
            action={
              toast.action ? (
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    toast.action?.onClick();
                    handleDismiss(toast.id);
                  }}
                >
                  {toast.action.label}
                </Button>
              ) : undefined
            }
          >
            {toast.message}
          </Alert>
        </Snackbar>
      ))}
    </Box>
  );
};

export default ToastContainer;
